import { render, staticRenderFns } from "./OrganizationDetailsPage.vue?vue&type=template&id=47cb6a74&scoped=true&"
import script from "./OrganizationDetailsPage.vue?vue&type=script&lang=js&"
export * from "./OrganizationDetailsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47cb6a74",
  null
  
)

export default component.exports